import { render, staticRenderFns } from "./section-title.vue?vue&type=template&id=f93a40d0"
import script from "./section-title.vue?vue&type=script&lang=ts"
export * from "./section-title.vue?vue&type=script&lang=ts"
import style0 from "./section-title.vue?vue&type=style&index=0&id=f93a40d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports